module.exports = __webpack_public_path__ + "static/media/cvs-front.7d76b502.png";